import TeamActivityAccordion from './TeamActivityAccordion'

export default TeamActivityAccordion



// WEBPACK FOOTER //
// ./src/legacy/components/TeamActivityAccordion/index.js